var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "steffi-profile-tab v-application vuetify-wrapper" },
    [
      _vm.isLoading
        ? _c("v-progress-linear", {
            attrs: { indeterminate: "", color: "primary" },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.error
        ? _c(
            "v-alert",
            {
              staticClass: "mt-4",
              attrs: { type: "error", dense: "", outlined: "" },
            },
            [
              _vm._v(
                "\n        Steffi Daten konnten nicht geladen werden.\n    "
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isLoading && !_vm.error
        ? _c(
            "section",
            [
              _c("v-checkbox", {
                attrs: {
                  label: "Offline-Testphase",
                  disabled: _vm.offlineTrialSaving,
                  loading: _vm.offlineTrialSaving,
                  "hide-details": "",
                  "data-test": "steffi-offline-trial",
                },
                on: { change: _vm.saveOfflineTrial },
                model: {
                  value: _vm.offlineTrial,
                  callback: function ($$v) {
                    _vm.offlineTrial = $$v
                  },
                  expression: "offlineTrial",
                },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "text-caption text--secondary mb-4" }, [
                _vm._v(
                  "\n            Das Aktivieren beendet eine laufende oder angefragte FPP-Testphase und verhindert weitere\n            FPP-Testphasen. Eine reguläre kostenpflichtige Buchung bleibt möglich.\n        "
                ),
              ]),
              _vm._v(" "),
              !_vm.isRestricted
                ? _c(
                    "v-card",
                    {
                      staticClass: "mb-4",
                      attrs: {
                        outlined: "",
                        rounded: "lg",
                        "data-test": "steffi-contact-email-card",
                      },
                    },
                    [
                      _c(
                        "v-card-text",
                        { staticClass: "d-flex align-center py-3" },
                        [
                          !_vm.steffiEmailEditing
                            ? _c("div", { staticClass: "flex-grow-1" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass: "text-caption text--secondary",
                                  },
                                  [
                                    _vm._v(
                                      "Steffi-E-Mail für die Steffi-Kommunikation"
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "strong",
                                  {
                                    attrs: {
                                      "data-test":
                                        "steffi-contact-email-display",
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.steffiEmail || "Nicht festgelegt"
                                      )
                                    ),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.steffiEmailEditing
                            ? [
                                _c("v-text-field", {
                                  staticClass: "mr-2",
                                  attrs: {
                                    label: "Steffi-E-Mail-Adresse",
                                    type: "email",
                                    outlined: "",
                                    dense: "",
                                    clearable: "",
                                    rules: [_vm.optionalEmailRule],
                                    disabled: _vm.steffiEmailSaving,
                                    "hide-details": "",
                                    "data-test": "steffi-contact-email",
                                  },
                                  model: {
                                    value: _vm.steffiEmailDraft,
                                    callback: function ($$v) {
                                      _vm.steffiEmailDraft = $$v
                                    },
                                    expression: "steffiEmailDraft",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      icon: "",
                                      small: "",
                                      color: "primary",
                                      loading: _vm.steffiEmailSaving,
                                      "data-test": "steffi-contact-email-save",
                                      "aria-label":
                                        "Steffi-E-Mail-Adresse speichern",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.saveSteffiEmail()
                                      },
                                    },
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("mdi-check"),
                                    ]),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: {
                                      icon: "",
                                      small: "",
                                      disabled: _vm.steffiEmailSaving,
                                      "data-test":
                                        "steffi-contact-email-cancel",
                                      "aria-label": "Bearbeiten abbrechen",
                                    },
                                    on: { click: _vm.cancelSteffiEmailEdit },
                                  },
                                  [
                                    _c("v-icon", { attrs: { small: "" } }, [
                                      _vm._v("mdi-close"),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            : _c(
                                "v-btn",
                                {
                                  attrs: {
                                    icon: "",
                                    small: "",
                                    "data-test": "steffi-contact-email-edit",
                                    "aria-label":
                                      "Steffi-E-Mail-Adresse bearbeiten",
                                  },
                                  on: { click: _vm.startSteffiEmailEdit },
                                },
                                [
                                  _c("v-icon", { attrs: { small: "" } }, [
                                    _vm._v("mdi-pencil"),
                                  ]),
                                ],
                                1
                              ),
                        ],
                        2
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.canCreateAdminOnboarding
                ? _c("steffi-admin-onboarding", {
                    attrs: {
                      "pharmacy-id": _vm.pharmacyId,
                      context: _vm.context,
                      "route-generation": _vm.steffiContextRequestGeneration,
                    },
                    on: { "context-updated": _vm.onChildContextUpdated },
                  })
                : _c("steffi-subscribed-pharmacy-view", {
                    attrs: {
                      "pharmacy-id": _vm.pharmacyId,
                      context: _vm.context,
                      "route-generation": _vm.steffiContextRequestGeneration,
                      "steffi-email-saving": _vm.steffiEmailSaving,
                      "steffi-email-save-success": _vm.steffiEmailSaveSuccess,
                    },
                    on: {
                      "context-updated": _vm.onChildContextUpdated,
                      "save-steffi-email": _vm.saveSteffiEmail,
                    },
                  }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }